import { extendServiceContainer } from '@iotize/tap';
import { WifiService } from './service';

declare module '@iotize/tap/lib/service-container' {
  interface ServiceContainer {
    wifi: WifiService;
  }
}

export const _TAP_SERVICE_EXTENSION_WIFI_ = extendServiceContainer(
  'wifi',
  WifiService,
);
